<!-- 推荐合作社 -->
<template>
<div class="info-block">
  <router-link  class="info-block-a" :to="'/zyhzs/hzsDetail/'+info.id"  target="_blank">
    <div class="div-1" v-bind:style="{backgroundImage:'url('+info.cover_img+')'}">
      <div class="div-1-1">{{info.title.length>15?(info.title.substring(0,15)+'...'):info.title}}</div>
      <div class="div-1-2">云南-昆明-富民</div>
      <div class="div-1-3">
        <a class="td-action-1">点击查看</a>
      </div>
    </div>
  </router-link>
</div>
</template>
<script>
export default {
  name: 'HyzhImgInfo',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  height:280px;
  padding:0px;
  margin:0px 0px 10px 0px;
  //background-color:green;
  border:1px solid #ddd;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center center;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  border:1px solid var(--color6);
  box-shadow:0px 0px 1px 0px var(--color6);
}

.div-1{
  position:relative;
  height:280px;
  width:100%;
  padding:150px 0px 0px 0px;
  //background:var(--color6);
  color:#fff;
  background-size: 100% 160px;
  background-repeat: no-repeat;
  background-position: center 0;
}

.div-1-1{
  height:40px;
  padding:10px;
  font-size:14px;
  font-weight:600;
  text-align:left;
  color:#515151;
}

.div-1-2{
  height:25px;
  padding:0px 10px 10px 10px;
  font-size:12px;
  font-weight:100;
  text-align:left;
  line-height:15px;
  color:var(--color7);
  //background:yellow;
}

.div-1-3{
  height:25px;
  padding:0px 10px 5px 25px;
  font-size:12px;

  text-align:left;
  line-height:15px;
  color:var(--color7);
  //background:red;
}

.div-1-3 .td-action-1{
  display:block;
  height:30px;
  width:100px;
  float:right;
  padding:5px 15px 5px 15px;
  margin-top:10px;
  border:1px solid var(--color1);
  font-size:12px;
  color:#515151;
  line-height:20px;
  text-align:center;
}

.td-action-1:hover{
  border:1px solid var(--color1);
  background:var(--color1);
  color:#fff;
}
</style>



// WEBPACK FOOTER //
// src/components/module/ZyhzsInfo2.vue